import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=771ff54a&scoped=true"
import script from "./NewTag.vue?vue&type=script&lang=js"
export * from "./NewTag.vue?vue&type=script&lang=js"
import "./NewTag.vue?vue&type=style&index=0&id=771ff54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ff54a",
  null
  
)

export default component.exports